import { render, staticRenderFns } from "./AdvancedSettingsTab.vue?vue&type=template&id=22a7cec1"
import script from "./AdvancedSettingsTab.vue?vue&type=script&lang=js"
export * from "./AdvancedSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports